import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useTileBadgeStyles = makeStyles({
    flyoutBadge: {
        left: 'auto',
        right: '18px',
    },
    draggingBadge: {
        opacity: 0.5,
        marginLeft: '2px',
        zIndex: 100,
    },
    transparentBorder: __assign({}, shorthands.border(0)),
    wideDotBadge: {
        top: '6px',
        left: '42px',
    },
    flyoutDotBadge: __assign({ height: '10px', width: '10px', left: '68px', top: '9px' }, shorthands.border('1px', 'solid', tokens.colorNeutralBackground4Selected)),
});
//# sourceMappingURL=TileBadge.styles.js.map